import { render, staticRenderFns } from "./ModalCrud.vue?vue&type=template&id=6dd835a9"
import script from "./ModalCrud.vue?vue&type=script&lang=js"
export * from "./ModalCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports